import { Controller, useFormContext } from 'react-hook-form';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { isEmpty, isString } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { getTimeZoneOptions, getTimeZoneShortName } from './FormConstants';
import {
    AUTO_COMPLETE_DEFAULT,
    DEFAULT_STYLE_INPUT_PROPS,
    GENERIC_REQUIRED_MESSAGE,
} from '../../utilities/FormUtilities';
import NgpField from './NgpField';

const useStyles = makeStyles(() => ({
    autoComplete: {
        '& .MuiAutocomplete-root': {
            width: 400,
        },
    },
}));

const timeZoneOptions = getTimeZoneOptions();

export function NgpTimeZoneField(fieldProps) {
    const classes = useStyles();
    const { control, errors } = useFormContext();
    const { fieldName, label, required = false, disabled = false } = fieldProps;

    const rules = required ? { required: GENERIC_REQUIRED_MESSAGE } : {};

    return (
        <NgpField {...fieldProps} errors={errors} fieldName={fieldName}>
            <div className={classes.autoComplete}>
                <Controller
                    render={({ onChange, ...props }) => (
                        <Autocomplete
                            disabled={disabled}
                            options={timeZoneOptions}
                            autoHighlight
                            autoSelect
                            getOptionLabel={(option) =>
                                !option || isString(option)
                                    ? `${option}${getTimeZoneShortName(option)}`
                                    : option?.pretty
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    {...DEFAULT_STYLE_INPUT_PROPS}
                                    label={label}
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: AUTO_COMPLETE_DEFAULT,
                                        size: 35,
                                    }}
                                    required={required}
                                    error={!isEmpty(errors[fieldName])}
                                />
                            )}
                            onChange={(e, data) => onChange(!data || isString(data) ? data : data.code)}
                            getOptionSelected={(option, currentValue) =>
                                option?.name === currentValue || option?.pretty === currentValue
                            }
                            {...props}
                        />
                    )}
                    onChange={([, data]) => data}
                    defaultValue={null}
                    name={fieldName}
                    control={control}
                    rules={rules}
                />
            </div>
        </NgpField>
    );
}
